import JWPlayerContent from './JWPlayerContent';

export default JWPlayerContent;
